// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1VOIc","upload":"Small_upload__3jvoG","imageWrap":"Small_imageWrap__IbUj6","removeBtn":"Small_removeBtn__16OwT"};